import { hydrateRoot } from 'react-dom/client';

import { anonymousId } from '@farmersdog/lead-browser-storage';

import { ClientApp } from './ClientApp';
import { initializeLogger } from './components/ErrorBoundary';

anonymousId.createIfNotExists();

initializeLogger();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find the root element');
}

hydrateRoot(rootElement, <ClientApp />);
